<template>
    <div>
        <div class="success-story-area pb-100">
            <div class="container" v-for="blogItem of blog" :key="blogItem.blog_id">
                <div class="video-box mt-0">
                    <div class="image">
                        <img :src="getImgUrl('bloglar', blogItem.blog_img)" class="shadow" alt="image">
                    </div>

                    <div class="shape10">
                        <img src="../../assets/img/shape/shape9.png" alt="image">
                    </div>
                </div>
                <div class="col-md-12" style="margin-top: 70px" v-html="blogItem.blog_content"></div>
            </div>
            <div class="shape2">
                <img src="../../assets/img/shape/shape2.png" alt="image">
            </div>
            <div class="shape3">
                <img src="../../assets/img/shape/shape3.png" alt="image">
            </div>
            <div class="shape4">
                <img src="../../assets/img/shape/shape4.png" alt="image">
            </div>
            <div class="shape9">
                <img src="../../assets/img/shape/shape8.svg" alt="image">
            </div>
        </div>


    </div>
</template>

<script>

import axios from "axios";

export default {
    name: 'SuccessStory',
    props: ['pathUrl'],

    created() {
        this.getBlog();
    },

    data: () => ({
        blog: [],
        errors: [],

    }),
    methods: {
        getUrl(data, pet) {
            return this.pathUrl + '?data=' + data + '&id=' + pet
        },
        getBlog() {
            axios
                .get(this.getUrl('blog_id', this.$route.params.id))
                .then(response => (this.blog = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getImgUrl(category, pet) {
            return require('../../../../assets/resimler/' + category + '/' + pet)
        }
    }
}
</script>